import React from 'react';
import SectionContainer from '../../../../F22/common/SectionContainer';
import FieldRow from '../../../../F22/common/FieldRow';
import { r19 as r19Fn } from '../formulas';

const R19Section = ({ data, computed }) => {
  return (
    <SectionContainer title="Recuadro N° 19" subtitle="CPTS Régimen Pro PYME (Art. 14 letra D) N° 3 LIR)">
      <div className="f22-subsection">
        <FieldRow label="CPT o CPTS positivo inicial" code="1445" sign="(+)" value={r19Fn.cptInicial(data)} computed />
        <FieldRow label="Capital aportado empresas que inician actividades en el año comercial" code="1374" sign="(+)" value={r19Fn.capitalAportado1374(data)} computed />
        <FieldRow label="Base imponible afecta a IDPC del ejercicio" code="1705" sign="(+)" value={r19Fn.biAfecta(data)} computed />
        <FieldRow label="Retiros o dividendos percibidos en el ejercicio" code="1726" sign="(+)" value={r19Fn.dividendosPercibidos(data)} computed />
        <FieldRow label="Remesas, retiros o dividendos repartidos" code="1479" sign="(-)" value={r19Fn.retiros(data)} computed />
        <FieldRow label="Partidas inc. 1° art. 21 LIR" code="1708" sign="(-)" value={r19Fn.partidasArt21(data)} computed />
        <FieldRow label="Crédito IPE contra IF del ejercicio" code="1379" sign="(-)" value={r19Fn.creditoIPE(data)} computed />
        <FieldRow label="Incentivo al ahorro art. 14 letra E)" code="1710" sign="(+)" value={r19Fn.incentivoAhorro(data)} computed />
        <FieldRow label="CPTS positivo final" code="1545" sign="(=)" value={computed.r19?.cptsPositivoFinal} computed className="f22-field-total" />
      </div>
    </SectionContainer>
  );
};

export default R19Section;
